export default __webpack_public_path__ + "static/media/female_mouth.07c23f98.png";